import "./Modal.scss";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import ReactDom from "react-dom";
import warningCircleIcon from "assets/icons/warning-circle.svg";
import { useRef } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import propTypes from "prop-types";
import { joinWeekDates } from "utils/fafHelper";
import { useDismiss } from "utils/customHooks";
import { useUserContext } from "api/user/UserProvider";

const FafLateDeclarationModal = ({ lateWeeks, onClose, onConfirm }) => {
  const intl = useIntl();
  const { lang } = useUserContext();
  const dialogRef = useRef(null);
  // Outside the dialog there is only the overlay: a click on it closes too.
  useDismiss({ open: true, onDismiss: onClose, ref: dialogRef });

  const count = lateWeeks.length;
  const dates = joinWeekDates({
    isoDates: lateWeeks,
    lang,
    separator: intl.formatMessage({
      id: "faf_late_declaration_dates_separator",
      defaultMessage: ", du ",
    }),
    lastSeparator: intl.formatMessage({
      id: "faf_late_declaration_dates_last_separator",
      defaultMessage: " et du ",
    }),
  });

  return ReactDom.createPortal(
    <>
      <div
        className="overlay-style"
        data-testid="faf-late-declaration-overlay"
      />
      <dialog
        open
        ref={dialogRef}
        className="validation-modal-style faf-late-declaration-modal"
        id="faf-late-declaration-modal"
        aria-modal="true"
        aria-labelledby="faf-late-declaration-title"
      >
        <div className="header">
          <Icon
            color="gray-200"
            icon="close"
            onClick={onClose}
            dataTestId="faf-late-declaration-close"
          />
        </div>
        <div className="body">
          <div>
            <img src={warningCircleIcon} className="validation-icon" alt="" />
          </div>
          <div className="title" id="faf-late-declaration-title">
            <FormattedMessage
              id="faf_late_declaration_title"
              defaultMessage="{count, plural, one {Ta déclaration F&F est en retard} other {Tes déclarations F&F sont en retard}}"
              values={{ count }}
            />
          </div>
          <div className="description">
            <p>
              <FormattedMessage
                id="faf_late_declaration_weeks"
                defaultMessage="{count, plural, one {La semaine du {dates} n'a pas été déclarée.} other {Les semaines du {dates} n'ont pas été déclarées.}}"
                values={{ count, dates }}
              />
            </p>
            <p>
              <FormattedMessage
                id="faf_late_declaration_call_to_action"
                defaultMessage="Fais ta déclaration Fast & Furious pour être à jour."
              />
            </p>
          </div>
          <div className="form-buttons">
            <Button
              color="btn-medium gray-700"
              type="button"
              onClick={onConfirm}
              id="button-faf-late-declaration-go"
            >
              <FormattedMessage
                id="faf_late_declaration_button"
                defaultMessage="Faire ma déclaration"
              />
            </Button>
          </div>
        </div>
      </dialog>
    </>,
    document.getElementById("portal")
  );
};

export default FafLateDeclarationModal;

FafLateDeclarationModal.propTypes = {
  lateWeeks: propTypes.arrayOf(propTypes.string).isRequired,
  onClose: propTypes.func.isRequired,
  onConfirm: propTypes.func.isRequired,
};
